<div class="config-page">
  <div class="config-toolbar">
    <div class="config-toolbar__copy">
      <p class="config-kicker">Room rules</p>
      <h2 class="config-title">My Configuration</h2>
    </div>

    <mat-form-field
      class="config-room-field"
      appearance="outline"
      *ngIf="hostRoom && hostRoom.length !== 1">
      <mat-label>Webinar Room</mat-label>
      <mat-select
        placeholder="Please select webinar room"
        (selectionChange)="GetConfigurations($event)"
        [formControl]="confRoomControl">
        <mat-option *ngFor="let webinarRoom of hostRoom" [value]="webinarRoom">
          {{ webinarRoom.roomName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="config-room-pill" *ngIf="hostRoom && hostRoom.length === 1">
      <mat-icon>storefront</mat-icon>
      <span>{{ selectedRoom?.roomName }}</span>
    </div>
  </div>

  <div class="config-actions" *ngIf="dislayData">
    <button type="button" class="config-photo-btn" (click)="onViewRoomImage()">
      <span class="config-photo-btn__thumb" [style.background-image]="roomImageSrc ? 'url(' + roomImageSrc + ')' : 'none'">
        <mat-icon *ngIf="!roomImageSrc">image</mat-icon>
      </span>
      <span class="config-photo-btn__copy">
        <strong>{{ roomImageSrc ? 'View business photo' : 'No business photo' }}</strong>
        <em>{{ roomImageSrc ? 'Open a full preview' : 'Add one from Update room details' }}</em>
      </span>
    </button>

    <button type="button" class="host-cta" (click)="onUpdateRoomImage()">
      Update room details
    </button>
  </div>

  <div class="config-grid" *ngIf="dislayData">
    <article
      class="config-card"
      *ngFor="let row of myConfigurationData; let i = index"
      [ngClass]="'config-card--' + slotTone(row.SlotTime, i)"
      tabindex="0">
      <div class="config-card__head">
        <span class="config-card__icon" aria-hidden="true">
          <mat-icon>{{ slotIcon(row.SlotTime, i) }}</mat-icon>
        </span>
        <div class="config-card__copy">
          <span class="config-card__kicker">Queue time slot</span>
          <h3 class="config-card__time">{{ formatTimeSlot(row.SlotTime) }}</h3>
        </div>
      </div>

      <div class="config-card__stats">
        <div class="config-stat">
          <span>Max for sale at once</span>
          <strong>{{ row.MaxItem }}</strong>
        </div>
        <div class="config-stat config-stat--accent">
          <span>Max to sell in period</span>
          <strong>{{ row.MaxItemsToSell }}</strong>
        </div>
      </div>
    </article>
  </div>

  <p class="config-note" *ngIf="dislayData">
    Sellers cannot change the max number of webinars for sale. Email admin if a slot needs a different cap.
  </p>
</div>

<div class="image-lightbox" *ngIf="showRoomImage" (click)="closeRoomImage()">
  <div class="image-lightbox__card" (click)="$event.stopPropagation()">
    <div class="image-lightbox__bar">
      <div>
        <p class="image-lightbox__kicker">Business photo</p>
        <h3>{{ selectedRoom?.roomName }}</h3>
      </div>
      <button type="button" class="image-lightbox__close" (click)="closeRoomImage()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <img *ngIf="roomImageSrc" [src]="roomImageSrc" [alt]="selectedRoom?.roomName + ' business photo'" />
    <div class="image-lightbox__empty" *ngIf="!roomImageSrc">
      <mat-icon>add_photo_alternate</mat-icon>
      <p>No business photo yet. Use Update room details to add one.</p>
    </div>
  </div>
</div>
